import * as R from 'ramda'
import { emoji as actions } from '../actions'
import * as selectors from '../selectors/emoji'
import { emoji as apiFetch } from 'src/lib/service'

export const initialState = {
  data: null,
  isFetching: false,
  didInvalidate: false,
  receivedAt: null
}

const shouldFetch = state => {
  const data = selectors.emojisSelector(state)
  const isFetching = selectors.isFetchingSelector(state)
  const didInvalidate = selectors.didInvalidateSelector(state)

  if (!data && !isFetching) {
    return true
  } else {
    return didInvalidate
  }
}

const makeRequest = {
  type: actions.MAKE_REQUEST
}

const receiveData = data => ({
  type: actions.RECEIVE_DATA,
  payload: {
    data,
    receivedAt: +new Date()
  }
})

export const invalidateData = () => dispatch =>
  dispatch({
    type: actions.INVALIDATE_DATA
  })

const fetch = (boardId, disabledEmojis) => async dispatch => {
  await dispatch(makeRequest)

  return apiFetch(boardId).then(({ body: allEmojis }) => {
    const filtered = disabledEmojis
      ? allEmojis.filter(
          emoji =>
            !disabledEmojis.map(R.prop('key')).includes(R.prop('key', emoji))
        )
      : allEmojis

    dispatch(receiveData(filtered))
    return filtered
  })
}

export const fetchEmojis = (boardId, disabledEmojis = []) => (
  dispatch,
  getState
) =>
  shouldFetch(getState())
    ? fetch(boardId, disabledEmojis)(dispatch)
    : Promise.resolve()
